import { render } from "./ConnectionServiceList.vue?vue&type=template&id=88524424"
import script from "./ConnectionServiceList.vue?vue&type=script&lang=js"
export * from "./ConnectionServiceList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__